<template>
    <div class="bg-white rounded shadow min-h-screen">
        <TodaySaleStat :currency-short-name="currentCurrencyShortName"/>

        <Row type="none" class="bg-white rounded shadow mt-3">
            <div class="container grid grid-cols-12 gap-3 py-4">
                <div class="col-span-12 lg:col-span-4 relative">
                    <img src="/images/search-interface-symbol.png" alt="" class="h-6 absolute left-2 top-2">
                    <b-form-input
                        class="border-gray-300 pl-10 w-full h-11"
                        v-model="search.productName"
                        :placeholder="$t('sale.product.title')"
                    />
                </div>
                <div class="col-span-12 sm:col-span-3 lg:col-start-5 lg:col-span-2">
                    <b-form-select
                        v-model="currentCurrencyShortName"
                        class="h-11 border-gray-300 focus:ring-0"
                    >
                        <b-form-select-option value="UZS">UZS</b-form-select-option>
                        <b-form-select-option value="USD">USD</b-form-select-option>
                        <b-form-select-option value="RUB">RUB</b-form-select-option>
                    </b-form-select>
                </div>
                <div class="col-span-12 sm:col-span-3 lg:col-span-2">
                    <b-form-select
                        v-model="statPeriod"
                        @change="defineStatPeriod"
                        class="h-11 border-gray-300 focus:ring-0"
                    >
                        <b-form-select-option :value="0">{{ $t('statistics.type.statByDay') }}</b-form-select-option>
                        <b-form-select-option :value="1">{{ $t('statistics.type.statByMonth') }}</b-form-select-option>
                        <b-form-select-option :value="2">{{ $t('statistics.type.statByYear') }}</b-form-select-option>
                    </b-form-select>
                </div>
                <div class="col-span-12 sm:col-span-6 lg:col-span-4">
                    <div v-if="isYearly">
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedYear"
                            :options="optionsYear"
                            @change="yearlyStat">
                        </b-form-select>
                    </div>

                    <div v-if="isMonthly" class="flex gap-3">
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedYear"
                            @change="monthlyStat"
                            :options="optionsYear">
                        </b-form-select>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedMonth"
                            :options="optionsMonth"
                            @change="monthlyStat">
                        </b-form-select>
                    </div>

                    <div v-if="isDaily">
                        <b-form-datepicker
                            :locale="$i18n.locale === 'uz' ? 'ru' : $i18n.locale"
                            style="height: 44px !important;"
                            class="border-gray-300 focus:ring-0"
                            id="example-datepicker"
                            v-model="currentDate"
                            :hide-header="hideHeader"
                            @input="dailyStat"
                        ></b-form-datepicker>
                    </div>
                </div>

                <div class="col-span-3">
                        <b-form-input
                            @keyup.enter="findCustomer"
                            v-model="search.givenName"
                            :placeholder="$t('person.givenName')"
                            class="border-gray-300 focus:ring-0 h-11"
                        />
                </div>

                <div class="col-span-3">
                    <b-form-input
                        @keyup.enter="findCustomer"
                        v-model="search.familyName"
                        :placeholder="$t('person.familyName')"
                        class="border-gray-300 focus:ring-0 h-11"
                    />
                </div>
                <div class="col-span-3">
                    <b-form-input
                        @keyup.enter="findCustomer"
                        v-model="search.companyName"
                        :placeholder="$t('company.name')"
                        class="border-gray-300 focus:ring-0 h-11"
                    />
                </div>
                <div class="col-span-3">
                    <button class="bg-main border-0 w-full hover:bg-hoverMain rounded h-11 focus:outline-none">
                        <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="findCustomer">
                    </button>
                </div>
            </div>

            <div class="grid grid-cols-12">
                <div class="col-span-12 pr-3">
                    <AreaChart :series="series" :options="chartOptionsArea" :height=350 />
                </div>
            </div>

            <!--    customer table desktop   -->
            <table class="d-none d-md-table w-full">
                <thead class="bg-lightGray">
                <tr class="h-11">
                    <td class="px-2 font-bold">{{ $t('name') }}</td>
                    <td class="px-2 font-bold">{{ $t('statistics.customer.amount') }}</td>
                    <td class="px-2 font-bold">{{ $t('statistics.employee.avgReceipt') }}</td>
                    <td class="px-2 font-bold">{{ $t('statistics.customer.sum') }}</td>
                    <td class="px-2 font-bold">{{ $t('statistics.categories.profit') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, itemIndex) of isDaily ? getSaleCustomerDaily : isMonthly ? getSaleCustomerMonthly : getSaleCustomerYearly"
                    :key="item.id"
                    class="h-11"
                    @click="selectCustomer(item.customer, false, itemIndex)"
                >
                    <td class="px-2 cursor-pointer text-main font-bold">
                        {{ getCustomerName(item) }}
                    </td>
                    <td class="px-2 cursor-pointer">
                        {{ item.purchaseCount }}
                    </td>
                    <td class="px-2 cursor-pointer">{{
                            showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, item.avgReceipt)
                        }}
                    </td>
                    <td class="px-2 cursor-pointer">{{
                            showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, item.totalPurchase)
                        }}
                    </td>
                    <td class="px-2 cursor-pointer">
                        {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, item.income) }}
                    </td>
                </tr>
                </tbody>
            </table>

            <!--    customer table mobile   -->
            <table class="w-full d-md-none">
                <tbody
                    v-for="(item, itemIndex) of isDaily ? getSaleCustomerDaily : isMonthly ? getSaleCustomerMonthly : getSaleCustomerYearly"
                    :key="item.id"
                    @click="selectCustomer(item.customer, false, itemIndex)"
                >
                <tr class="h-11">
                    <td class="px-2 font-bold">{{ $t('name') }}</td>
                    <td class="px-2 cursor-pointer font-bold text-main">
                        {{ getCustomerName(item) }}
                    </td>
                </tr>
                <tr class="h-11">
                    <td class="px-2 font-bold">{{ $t('statistics.customer.amount') }}</td>
                    <td class="px-2 cursor-pointer">
                        {{ item.purchaseCount }}
                    </td>
                </tr>
                <tr class="h-11">
                    <td class="px-2 font-bold">{{ $t('statistics.employee.avgReceipt') }}</td>
                    <td class="px-2 cursor-pointer">{{
                            showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, item.avgReceipt)
                        }}
                    </td>
                </tr>
                <tr class="h-11">
                    <td class="px-2 font-bold">{{ $t('statistics.customer.sum') }}</td>
                    <td class="px-2 cursor-pointer">{{
                            showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, item.totalPurchase)
                        }}
                    </td>
                </tr>
                <tr class="h-11" style="border-bottom: 5px solid dimgray">
                    <td class="px-2 font-bold">{{ $t('statistics.categories.profit') }}</td>
                    <td class="px-2 cursor-pointer">
                        {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, item.income) }}
                    </td>
                </tr>
                </tbody>
            </table>
        </Row>
    </div>
</template>

<script>
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import AreaChart from "@/pages/Statistics/Charts/AreaChart.vue";
import {mapActions, mapGetters} from "vuex";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import TodaySaleStat from "@/components/TodaySaleStat.vue";
import Row from "@/components/html/Row.vue";

export default {
    name: "CustomerStat",
    components: {Row, TodaySaleStat, AreaChart},
    mixins: [currencyFormatMixin, currencyRateMixin, dateFormattingMixin],
    data() {
        return {
            isDaily: true,
            isMonthly: false,
            isYearly: false,
            selectedYear: null,
            selectedMonth: null,
            index: null,
            statPeriod: 0,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'statistics.customer.title'},
            ],
            optionsMonth: [
                {value: {start: '01-01', end: '01-31'}, text: this.$t('statistics.month.Jan')},
                {value: {start: '02-01', end: '02-28'}, text: this.$t('statistics.month.Feb')},
                {value: {start: '03-01', end: '03-31'}, text: this.$t('statistics.month.Mar')},
                {value: {start: '04-01', end: '04-30'}, text: this.$t('statistics.month.Apr')},
                {value: {start: '05-01', end: '05-31'}, text: this.$t('statistics.month.May')},
                {value: {start: '06-01', end: '06-30'}, text: this.$t('statistics.month.Jun')},
                {value: {start: '07-01', end: '07-31'}, text: this.$t('statistics.month.Jul')},
                {value: {start: '08-01', end: '08-31'}, text: this.$t('statistics.month.Aug')},
                {value: {start: '09-01', end: '09-30'}, text: this.$t('statistics.month.Sep')},
                {value: {start: '10-01', end: '10-31'}, text: this.$t('statistics.month.Oct')},
                {value: {start: '11-01', end: '11-30'}, text: this.$t('statistics.month.Nov')},
                {value: {start: '12-01', end: '12-31'}, text: this.$t('statistics.month.Dec')},
            ],
            purchaseCount: 0,
            hours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
            days: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
            month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            optionsYear: [],
            currentDate: null,
            currentMonth: null,
            hideHeader: false,
            series: [{
                name: this.$t('statistics.categories.soldProducts'),
                data: []
            }],
            date: {
                dateFrom: null,
                dateTo: null,
                customer: null
            },
            chartOptionsArea: {
                chart: {
                    id: '1',
                    type: 'area',
                    toolbar: {
                        show: false,
                    }
                },
                grid: {
                    show: true,
                    borderColor: '#F6F7FB',
                },
                colors: ['#8300C5'],
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    show: true,
                    curve: 'smooth',
                    lineCap: 'round',
                    colors: undefined,
                    width: 1,
                    dashArray: 0,
                },
                xaxis: {
                    min: 1,
                    title: {
                        text: this.$t('statistics.xaxis.hour') + '/' + this.$t('statistics.xaxis.day'),
                        offsetX: 0,
                        offsetY: -10,
                        style: {
                            color: '#8300C5',
                            fontSize: '12px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            cssClass: 'apexcharts-xaxis-title',
                        },
                    },
                },
                yaxis: {
                    showAlways: false,
                    decimalsInFloat: 0,
                    labels: {
                        show: true,
                        formatter: function abbrNum(number, decPlaces) {
                            decPlaces = Math.pow(10, decPlaces);

                            let abbrev = ["k", "m", "b", "t"];

                            for (let i = abbrev.length - 1; i >= 0; i--) {
                                let size = Math.pow(10, (i + 1) * 3);

                                if (size <= number) {
                                    number = Math.round(number * decPlaces / size) / decPlaces;

                                    if ((number === 1000) && (i < abbrev.length - 1)) {
                                        number = 1;
                                        i++;
                                    }

                                    number += abbrev[i];

                                    break;
                                }
                            }

                            return number;
                        }
                    },
                    tickAmount: 6,
                },
                responsive: [
                    {
                        breakpoint: 500,
                        options: {
                            chart: {
                                height: 300,
                                width: '100%',
                                type: 'area',
                                toolbar: {
                                    show: false,
                                }
                            },
                            xaxis: {
                                labels: {
                                    show: true,
                                    style: {
                                        fontSize: '8px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 400,
                                        cssClass: 'apexcharts-xaxis-label',
                                    },
                                },
                                title: {
                                    show: false,
                                    text: '',
                                },
                            },
                            yaxis: {
                                title: {
                                    show: false,
                                    text: '',
                                },
                                tickAmount: 10,
                                labels: {
                                    style: {
                                        fontSize: '8px',
                                        fontFamily: 'Helvetica, Arial, sans-serif',
                                        fontWeight: 400,
                                        cssClass: 'apexcharts-yaxis-label',
                                    },
                                    formatter: function abbrNum(number, decPlaces) {
                                        decPlaces = Math.pow(10, decPlaces);

                                        let abbrev = ["k", "m", "b", "t"];

                                        for (let i = abbrev.length - 1; i >= 0; i--) {
                                            let size = Math.pow(10, (i + 1) * 3);

                                            if (size <= number) {
                                                number = Math.round(number * decPlaces / size) / decPlaces;

                                                if ((number === 1000) && (i < abbrev.length - 1)) {
                                                    number = 1;
                                                    i++;
                                                }

                                                number += abbrev[i];

                                                break;
                                            }
                                        }

                                        return number;
                                    }
                                }
                            },
                        },
                    },
                ]

            },
            search: {
                companyName: null,
                dateFrom: '',
                dateTo: '',
                isDaily: false,
                isMonthly: false,
                givenName: null,
                familyName: null,
                page: 1,
                isNeedFetch: false
            }
        }
    },
    computed: {
        ...mapGetters([
            'getCompanyPayTypeStatistics',
            'getCurrencyByShortName',
            'getUserCompanyCreatedAt',
            'getSaleDaily',
            'getSaleMonthly',
            'getSaleYearly',
            'getSaleCustomerDaily',
            'getSaleCustomerMonthly',
            'getSaleCustomerYearly',
            'getSaleCustomerDailyPurchaseCount',
            'getSaleCustomerMonthlyPurchaseCount',
            'getSaleCustomerYearlyPurchaseCount',
            'getSaleCustomerDailyStat',
            'getSaleCustomerMonthlyStat',
            'getSaleCustomerYearlyStat',
            'getCustomers'
        ])
    },
    methods: {
        ...mapActions([
            'fetchCompanyPayTypeStatistics',
            'fetchUser',
            'fetchSaleDailyStat',
            'fetchSaleMonthlyStat',
            'fetchSaleYearlyStat',
            'fetchSaleCustomerDaily',
            'fetchSaleCustomerMonthly',
            'fetchSaleCustomerYearly',
            'fetchSaleCustomerDailyPurchaseCount',
            'fetchSaleCustomerMonthlyPurchaseCount',
            'fetchSaleCustomerYearlyPurchaseCount',
            'fetchSaleCustomerDailyStat',
            'fetchSaleCustomerMonthlyStat',
            'fetchSaleCustomerYearlyStat',
            'searchOneCustomer',
            'setBreadcrumbItems'
        ]),
        defineStatPeriod() {
            if (this.statPeriod === 0) {
                this.statByDays()
            } else if (this.statPeriod === 1) {
                this.statByMonth()
            } else {
                this.statByYear()
            }
        },
        statByDays() {
            this.isDaily = true
            this.isMonthly = false
            this.isYearly = false
            this.index = null
            this.search.givenName = null
            this.search.familyName = null
            this.search.companyName = null
            this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true
            this.$store.state.saleDaily.saleDaily.isNeedFetch = true
            this.$store.state.saleCustomerDaily.saleCustomerDaily.isNeedFetch = true
            this.$store.state.saleCustomerDaily.saleCustomerDailyPurchaseCount.isNeedFetch = true
            this.currentDate = this.getTodayDate()
            let date = {dateFrom: this.getTodayDate() + ' 00:00:00', dateTo: this.getTodayDate() + ' 23:59:59', page: 1}

            this.fetchCompanyPayTypeStatistics(date)
            this.fetchSaleCustomerDailyPurchaseCount(date)
                .then(() => {
                    this.purchaseCount = this.getSaleCustomerDailyPurchaseCount
                })

            this.fetchSaleCustomerDaily(date)
            this.fetchSaleDailyStat()
                .then(() => {
                    this.series[0].data = this.getSaleDaily

                    this.updateChartOptions('1', this.hours, 'hour')
                })
        },
        statByMonth() {
            this.isDaily = false
            this.isMonthly = true
            this.isYearly = false
            this.index = null
            this.search.givenName = null
            this.search.familyName = null
            this.search.companyName = null
            this.series[0].data = this.getSaleMonthly
            this.search.dateFrom = this.selectedYear + '-' + this.selectedMonth.start
            this.search.dateTo = this.selectedYear + '-' + this.selectedMonth.end
            this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true
            this.$store.state.saleCustomerMonthly.saleCustomerMonthly.isNeedFetch = true

            this.fetchCompanyPayTypeStatistics(this.search)
            this.fetchSaleCustomerMonthlyPurchaseCount(this.search)
                .then(() => {
                    this.purchaseCount = this.getSaleCustomerMonthlyPurchaseCount
                })
            this.fetchSaleCustomerMonthly(this.search)
            this.updateChartOptions('1', this.days, 'day')
        },
        statByYear() {
            this.isDaily = false
            this.isMonthly = false
            this.isYearly = true
            this.index = null
            this.search.givenName = null
            this.search.familyName = null
            this.search.companyName = null
            this.series[0].data = this.getSaleYearly
            this.search.dateFrom = this.selectedYear + '-' + 1 + '-' + 1
            this.search.dateTo = this.selectedYear + '-' + 12 + '-' + 31
            this.$store.state.saleCustomerYearly.saleCustomerYearly.isNeedFetch = true
            this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true

            this.fetchCompanyPayTypeStatistics(this.search)
            this.fetchSaleCustomerYearlyPurchaseCount(this.search)
                .then(() => {
                    this.purchaseCount = this.getSaleCustomerYearlyPurchaseCount
                })
            this.fetchSaleCustomerYearly(this.search)
            this.updateChartOptions('1', this.month, 'year')
        },
        dailyStat() {
            let date = {dateFrom: this.currentDate + 'T00:00:00', dateTo: this.currentDate + 'T23:59:59', isDaily: true, page: 1}
            this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true
            this.$store.state.saleCustomerDaily.saleCustomerDaily.isNeedFetch = true
            this.$store.state.saleDaily.saleDaily.isNeedFetch = true
            this.$store.state.saleCustomerDaily.saleCustomerDailyPurchaseCount.isNeedFetch = true
            this.index = null

            this.fetchSaleCustomerDaily(date)
            this.fetchSaleCustomerDailyPurchaseCount(date)
                .then(() => {
                    this.purchaseCount = this.getSaleCustomerDailyPurchaseCount
                })

            this.fetchCompanyPayTypeStatistics(date)
            this
                .fetchSaleDailyStat(date)
                .then(() => {
                    this.series[0].data = this.getSaleDaily
                    this.updateChartOptions('1', this.hours, 'hour')
                })
        },
        monthlyStat() {
            if (this.selectedYear === null && this.selectedMonth === null) {
                return
            }

            this.search.dateFrom = this.selectedYear + '-' + this.selectedMonth.start + 'T00:00:00'
            this.search.dateTo = this.selectedYear + '-' + this.selectedMonth.end + 'T23:59:59'
            this.search.isMonthly = true
            this.index = null
            this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true
            this.$store.state.saleMonthly.saleMonthly.isNeedFetch = true
            this.$store.state.saleCustomerMonthly.saleCustomerMonthly.isNeedFetch = true

            this.fetchSaleCustomerMonthly(this.search)
            this.fetchCompanyPayTypeStatistics(this.search)
            this
                .fetchSaleMonthlyStat({date: this.search.dateFrom})
                .then(() => {
                    this.series[0].data = this.getSaleMonthly
                    this.updateChartOptions('1', this.days, 'day')
                })
        },
        yearlyStat() {
            let date = {dateFrom: this.selectedYear + '-01-01T00:00:00', dateTo: this.selectedYear + '-12-31T23:59:59', page: 1}
            this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true
            this.$store.state.saleYearly.saleYearly.isNeedFetch = true
            this.$store.state.saleCustomerYearly.saleCustomerYearly.isNeedFetch = true
            this.index = null

            this.fetchSaleCustomerYearly(date)
            this.fetchCompanyPayTypeStatistics(date)
            this.fetchSaleCustomerYearlyPurchaseCount(date)
                .then(() => {
                    this.purchaseCount = this.getSaleCustomerYearlyPurchaseCount
                })
            this
                .fetchSaleYearlyStat({year: parseInt(this.selectedYear)})
                .then(() => {
                    this.series[0].data = this.getSaleYearly
                    this.updateChartOptions('1', this.month, 'year')
                })
        },
        updateChartOptions(chartId, categories, text) {
            this.$apexcharts.exec(chartId, 'updateOptions', {
                xaxis: {
                    type: 'category',
                    categories: categories,
                    title: {
                        text: this.$t(`statistics.xaxis.${text}`),
                    }
                }
            })
        },
        getTodayDate() {
            let yearNow = new Date().getFullYear()
            let monthNow = new Date().getMonth() + 1
            let dateNow = new Date().getDate()

            return yearNow + '-' + this.addZero(monthNow) + '-' + this.addZero(dateNow)
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
        async createYear() {
            let created = parseInt(this.getUserCompanyCreatedAt)

            while (created <= new Date().getFullYear()) {
                this.optionsYear.unshift({value: created, text: created})
                created++
            }

            await this.setYear()
        },
        setYear() {
            this.selectedYear = this.optionsYear[0].value
        },
        dateSwitcher() {
            this.selectedMonth = this.optionsMonth[this.currentMonth - 1].value
        },
        getCustomerName(item) {
            return item.customer.isCompany ? item.customer.customerCompany.name : item.customer.person.givenName + ' ' + item.customer.person.familyName
        },
        findCustomer() {
            this.searchOneCustomer(this.search)
                .then(() => {
                    if (this.getCustomers.length > 0) {
                        this.selectCustomer(this.getCustomers[0], true)
                    } else {
                        this.$i18nHelper.flash(this.$t('customer.notExist'), 'warning')
                    }
                })
        },
        dateHelper() {
            if (this.isDaily) {
                this.date.dateFrom = this.currentDate + ' 00:00:00'
                this.date.dateTo = this.currentDate + ' 23:59:59'
                this.search.dateFrom = this.currentDate + ' 00:00:00'
                this.search.dateTo = this.currentDate + ' 23:59:59'
            } else if (this.isMonthly) {
                this.date.dateFrom = this.selectedYear + '-' + this.selectedMonth.start + 'T00:00:00'
                this.date.dateTo = this.selectedYear + '-' + this.selectedMonth.end + 'T23:59:59'
                this.search.dateFrom = this.selectedYear + '-' + this.selectedMonth.start + 'T00:00:00'
                this.search.dateTo = this.selectedYear + '-' + this.selectedMonth.end + 'T23:59:59'
            } else {
                this.date.dateFrom = this.selectedYear + '-01-01T00:00:00'
                this.date.dateTo = this.selectedYear + '-12-31T23:59:59'
                this.search.dateFrom = this.selectedYear + '-01-01T00:00:00'
                this.search.dateTo = this.selectedYear + '-12-31T23:59:59'
            }
        },
        selectCustomer(customer, isSearch = false, itemIndex = null) {

            if (itemIndex !== null) {
                this.index = itemIndex
            }

            this.dateHelper()
            this.date.customer = customer.id

            if (this.isDaily) {
                this.$store.state.sale.saleCustomerDailyStat.isNeedFetch = true
                this.$store.state.saleCustomerDaily.saleCustomerDailyPurchaseCount.isNeedFetch = true
                this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true


                if (isSearch) {
                    this.$store.state.saleCustomerDaily.saleCustomerDaily.isNeedFetch = true
                    this.fetchSaleCustomerDaily(this.search)
                }

                this.fetchSaleCustomerDailyStat(this.date)
                    .then(() => {
                        this.series[0].data = this.getSaleCustomerDailyStat
                        this.updateChartOptions('1', this.hours, 'hour')
                    })

                this.fetchSaleCustomerDailyPurchaseCount(this.date)
                    .then(() => {
                        this.purchaseCount = this.getSaleCustomerDailyPurchaseCount
                    })

                this.fetchCompanyPayTypeStatistics(this.date)
            } else if (this.isMonthly) {
                this.$store.state.saleCustomerDaily.saleCustomerDailyPurchaseCount.isNeedFetch = true
                this.$store.state.saleCustomerDaily.saleCustomerMonthlyStat.isNeedFetch = true
                this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true

                if (isSearch) {
                    this.$store.state.saleCustomerMonthly.saleCustomerMonthly.isNeedFetch = true
                    this.fetchSaleCustomerMonthly(this.search)
                }

                this.fetchSaleCustomerMonthlyStat(this.date)
                    .then(() => {
                        this.series[0].data = this.getSaleCustomerMonthlyStat
                        this.updateChartOptions('1', this.days, 'day')
                    })

                this.fetchSaleCustomerMonthlyPurchaseCount(this.date)
                    .then(() => {
                        this.purchaseCount = this.getSaleCustomerMonthlyPurchaseCount
                    })

                this.fetchCompanyPayTypeStatistics(this.date)
            } else {
                this.$store.state.saleCustomerMonthly.saleCustomerYearlyStat.isNeedFetch = true
                this.$store.state.company.companyPayTypeStatistics.isNeedFetch = true
                this.$store.state.saleCustomerYearly.saleCustomerYearlyPurchaseCount.isNeedFetch = true

                if (isSearch) {
                    this.$store.state.saleCustomerYearly.saleCustomerYearly.isNeedFetch = true
                    this.fetchSaleCustomerYearly(this.search)
                }
                this.fetchSaleCustomerYearlyStat(this.date)
                    .then(() => {
                        this.series[0].data = this.getSaleCustomerYearlyStat
                        this.updateChartOptions('1', this.month, 'year')
                    })

                this.fetchSaleCustomerYearlyPurchaseCount(this.date)
                    .then(() => {
                        this.purchaseCount = this.getSaleCustomerYearlyPurchaseCount
                    })

                this.fetchCompanyPayTypeStatistics(this.date)
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this
            .fetchUser()
            .then(() => {
                this.currentMonth = new Date().getUTCMonth() + 1
                this.currentDate = this.getTodayDate()
                this.createYear()
                this.dateSwitcher()

                this.fetchSaleDailyStat()
                    .then(() => {
                        this.statByDays()
                        this.$root.showOverlay = false
                        this.$i18nHelper.flash(this.$t('statistics.info.gap'), 'info')
                    })
                    .catch((error) => {
                        console.log(error)
                        this.$root.showOverlay = false
                    })
                this.fetchSaleMonthlyStat()
                    .catch((error) => {
                        console.log(error)
                    })
                this.fetchSaleYearlyStat()
                    .catch((error) => {
                        console.log(error)
                    })
            })
            .catch((error) => {
                console.log(error)
                this.$root.showOverlay = false
            })
    }
}
</script>

<style scoped>

table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>
